import { memo, useMemo } from 'react';
import { isKnownGuid, getGuidLabel } from 'customer-data-objects/property/knownGuidUtils';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import InternalValueTooltip from './externalOptions/InternalValueTooltip';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import { useProperty } from '../v2/hooks/useProperty';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputKnownGuid = props => {
  useComponentMountMetric('PropertyInputKnownGuid');
  const {
    inputRef
  } = props;
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const value = usePropertyValue();
  const displayValue = useMemo(() => {
    if (!value || !isKnownGuid(value)) {
      return value || '';
    }
    return getGuidLabel(value);
  }, [value]);
  const input = /*#__PURE__*/_jsx(TextInput, Object.assign({}, getTransferrableProps(props), {
    readOnly: true,
    inputRef: inputRef,
    value: displayValue
  }));
  if (!value || !isKnownGuid(value)) {
    return input;
  }
  return /*#__PURE__*/_jsx(InternalValueTooltip, {
    internalValue: value,
    objectTypeId: objectTypeId,
    property: property,
    children: input
  });
};
export default /*#__PURE__*/memo(PropertyInputKnownGuid);